const DateFormats = {
  Y_M_D: "yyyy-MM-dd",
  Y_M_D_NO_DASH: "yyyyMMdd",
};

export default DateFormats;
